module.exports = __webpack_public_path__ + "img/purchases.26457e10.svg";